export const customStyles = {
	control: (base) => ({
		...base,
		borderTopLeftRadius: "10px",
		borderBottomLeftRadius: "10px",
		border: "1px solid #7fb02f",
		borderRight: "none",
		backgroundColor: "white",
		color: "#7fb02f",
		boxShadow: "none",
		minHeight: "44px",
		height: "44px",
		borderRadius: "10px 0px 0px 10px",
		fontSize: "14px",
		"&:hover": { borderColor: "#709730" },
	}),
	valueContainer: (base) => ({
		...base,
		height: "44px",
		padding: "0 8px",
	}),
	indicatorsContainer: (base) => ({
		...base,
		height: "44px",
	}),
	option: (base, state) => ({
		...base,
		color: state.isSelected ? "#fff" : "#333",
		backgroundColor: state.isSelected ? "#7fb02f" : "white",
		fontSize: "14px",
		zIndex: 2,
	}),
	singleValue: (base) => ({
		...base,
		color: "#7fb02f",
	}),
};

export const customStylesCustomer = {
	control: (base) => ({
		...base,
		border: "1px solid #7fb02f",
		backgroundColor: "white",
		color: "#7fb02f",
		boxShadow: "none",
		minHeight: "44px",
		minWidth: "150px",
		borderRadius: "5px",
		fontSize: "14px",
		"&:hover": { borderColor: "#709730" },
	}),
	option: (base, state) => ({
		...base,
		color: state.isSelected ? "#fff" : "#333",
		backgroundColor: state.isSelected ? "#7fb02f" : "white",
		fontSize: "14px",
	}),
	singleValue: (base) => ({
		...base,
		color: "#7fb02f",
	}),
};

export const routeSearch = [
	"/inventario",
	"/orden_compra",
	"/historiales/compra",
	"/historiales/salida",
	"/historiales/en_uso",
	"/historiales/usos",
	"/historiales/otros_movimientos",
	"/envases_vacios",
	"/facturas",
	"/guias_despacho",
	"/sin_documento",
	"/nota_credito",
	"/ordenes_compra",
	"/mantenedores/usuarios",
	"/mantenedores/productos",
	"/mantenedores/distribuidores",
	"/mantenedores/balanzas",
	"/configuracion/usuarios",
	"/mantenedores/razones_sociales",
	"/configuracion/razones_sociales",
	"/mantenedores/campos",
	"/configuracion/campos",
	"/mantenedores/operadores",
	"/configuracion/operadores",
	"/configuracion/transportistas",
	"/mantenedores/categorias",
	"/configuracion/categorias",
	"/mantenedores/paso-1",
	"/configuracion/paso-1",
	"/mantenedores/paso-2",
	"/configuracion/paso-2",
	"/mantenedores/paso-3",
	"/configuracion/paso-3",
	"/mantenedores/centro_costo",
	"/configuracion/centro_costo",
	"/configuracion/riegos",
	"/mantenedores/aptitudes",
	"/mantenedores/aplicaciones",
	"/mantenedores/codigos",
	"/mantenedores/ingredientes_activos",
	"/mantenedores/clientes",
	"/configuracion/grupos_campos",
	"/mantenedores/grupos_campos",
	"/ordenes_aplicacion",
	"/planificacion/ordenes_aplicacion",
	"/productos/genericos",
	"/productos/etiquetados",
	"/configuracion/estado_fenologico_oa",
	"/configuracion/objetivos_oa",
	"/configuracion/maquinarias",
	"/configuracion/listas_difusion",
];

export const routeOptions = {
	"/ordenes_compra": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° OC" },
		{ value: "order_delivery", label: "N° Guía de Despacho" },
		{ value: "dealer_number", label: "N° Factura" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
	],
	"/facturas": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Factura" },
		{ value: "order_code", label: "N° OC" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
	],
	"/guias_despacho": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Guía de Despacho" },
		{ value: "order_code", label: "N° OC" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
	],
	"/sin_documento": [
		{ value: "", label: "Buscar por" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
	],
	"/inventario": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/ordenes_aplicacion": [
		{ value: "", label: "Buscar por" },
		{ value: "code", label: "N° OA" },
		{ value: "product_name", label: "Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/planificacion/ordenes_aplicacion": [
		{ value: "", label: "Buscar por" },
		{ value: "code", label: "N\u00b0 OA" },
		{ value: "product_name", label: "Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/historiales/compra": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/historiales/salida": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/historiales/en_uso": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
	"/historiales/usos": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
		{ value: "output_code", label: "Cód. Movimiento" },
	],
	"/historiales/otros_movimientos": [
		{ value: "", label: "Buscar por" },
		{ value: "document_number", label: "N° Documento" },
		{ value: "dealer", label: "Proveedor" },
		{ value: "product_name", label: "Producto" },
		{ value: "product_code", label: "Cód. Producto" },
		{ value: "active_ingredient", label: "Ingrediente Activo" },
	],
};
